import { render } from "./ButtonArrow.vue?vue&type=template&id=55f5fbdb&scoped=true&ts=true"
import script from "./ButtonArrow.vue?vue&type=script&lang=ts"
export * from "./ButtonArrow.vue?vue&type=script&lang=ts"

import "./ButtonArrow.vue?vue&type=style&index=0&id=55f5fbdb&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f5fbdb"]])

export default __exports__